import 'intersection-observer';
import { kv } from './_kv.js';
import { anker } from './_anker.js';
import { newsSwiper } from './_news-swiper.js';
import { titleAnime } from './_title-anime.js';
import { cardIntoView } from './_card-intoview.js';
import { header } from './_header.js';

document.addEventListener('DOMContentLoaded', ()=>{
  if(document.getElementById('kv')){
    kv.init();
  }
  if(document.getElementById('news-swiper')){
    newsSwiper.init();
  }
  anker.init();
  titleAnime.init();
  cardIntoView.init();
  header.init();
})
